<template>
  <div>
    <b-card>
        <h6><strong>Open Tasks</strong></h6>
        <b-list-group-item class="text-center" v-if="tblLoader">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </b-list-group-item>
        <b-list-group class="task-scrollable" v-else>
          <b-list-group-item v-for="(task) in itemData" :key="task.id" class="flex-column align-items-start"
                             :class="task.selected ? 'selected':''">
            <div class="d-flex w-100 justify-content-between">
              <div class="d-flex">
                <i class="fa fa-2x mr-2" :class="findIconClass(task.taskTypeId)"></i>
                <b-link href="#" @click="onRowClick(task)"><h5>{{task.taskPriorityName}} - {{task.subject}}</h5></b-link>
              </div>
              <div class=" h5 float-right">{{task.taskStatusName}}</div>
            </div>
            <div class="d-flex w-100 justify-content-between mt-1">
              <div>
                <div class="h6 m-0">Contact / Company</div>
                <div>
                  <router-link :to="`/company/${task.companyId}/contacts/${task.contactId}`">
                    {{task.contactFirstName}} {{task.contactLastName}}
                  </router-link>
                  /
                  <router-link :to="`/company/${task.companyId}/details`">
                    {{task.companyName}}
                  </router-link>
                </div>
              </div>
              <h6>{{task.accountType}}</h6>
            </div>
            <div class="d-flex w-100 mt-1">
              <div class="mr-3">
                <div class="h6 m-0">Assigned</div>
                <div>{{task.assignedToUserFullName}}</div>
              </div>
              <div class="mr-3">
                <div class="h6 m-0">Due</div>
                <div>{{task.taskDueDateString}} {{task.taskDueHour}}:{{task.taskDueMinute}} {{task.taskDueAmPm}}</div>
              </div>
              <div class="mr-3">
                <div class="h6 m-0">Aging</div>
                <div>{{task.aging}} days</div>
              </div>
            </div>
          </b-list-group-item>
          <b-list-group-item href="#"><h6 v-if="!itemData.length">No records found.</h6></b-list-group-item>
        </b-list-group>
      <b-modal id="task-detail-modal" size="xl" ok-only>
        <TaskDetail v-if="taskDetails.id" :assignedUsers="getAllUser" :taskDetails="taskDetails"
                    @refreshGrid="getTaskList" @openTodoModal="openTodoModal"/>
      </b-modal>
    </b-card>
    <add-task :editDetails="editDetails" @refreshGrid="getTaskList"/>
    <CloseTask :taskDetails="taskDetails" @refreshGrid="getTaskList"/>
  </div>
</template>

<script>
  import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
  import { debounce } from 'lodash';
  import { GRID_ID, TODO_TASK_TYPES } from '@/shared/constants';
  import GridSettings from '@/shared/components/GridSettings';
  import GridComponent from '@/shared/components/GridComponent';
  import gridFields from '@/pages/Todotasks/fields';
  import DateRangePicker from '@/shared/components/DateRangePicker/IndexNew';
  import TaskDetail from '@/pages/Todotasks/components/detail';
  import AddTask from '@/pages/Todotasks/components/add';
  import CloseTask from '@/pages/Todotasks/components/close';
  import { roleMixin } from '@/shared/helpers';
  import FixedHeader from '@/shared/components/FixedHeader/indexNew';

  const SEARCH_DEBOUNCE_TIME = 750;

  export default {
    components: {
      GridSettings,
      GridComponent,
      DateRangePicker,
      TaskDetail,
      AddTask,
      CloseTask,
      FixedHeader
    },
    data() {
      return {
        fields: gridFields,
        gridId: GRID_ID.TODOTASKS,
        pageable: {
          pageSizes: 0,
        },
        selectedRowItemId: 0,
        taskTypes: TODO_TASK_TYPES,
        taskDetails: {},
        editDetails: {},
        taskStatusType: [{ id: 410, name: 'Open' }, { id: 411, name: 'Close' }],
        filterPageName: 'todoListPage'
      };
    },
    computed: {
      ...mapGetters('todotasks', [
        'gridList',
        'pageInfo',
        'filters',
        'selectedItemId',
        'tblLoader',
      ]),
      ...mapGetters('account', ['gridSettingsById','userId']),
      ...mapGetters('users', ['getAllUser']),
      gridSettings() {
        return this.gridSettingsById(this.gridId);
      },
      itemData() {
        if (this.gridList == undefined || this.gridList.length === 0) return [];
        return this.gridList.map((task) => ({ ...task, selected: task.id === this.selectedRowItemId }));
      },
      filtersObj() {
        return this.filters[this.filterPageName] || {}
      },
    },
    methods: {
      ...mapActions('todotasks', ['getAll', 'search', 'clearFilters']),
      ...mapMutations('todotasks', ['setItem']),
      ...mapActions('users', { 'getAllUserList': 'getAll' }),
      ...mapActions('account', ['saveGridSettings']),
      onSearch: debounce(function() {
        this.selectedRowItemId = 0;
        if(!roleMixin.methods.checkClaim(roleMixin.data().CAN_MANAGE_TASKS)) {this.filtersObj.assignedTo = this.userId;}
        this.search({'filters':this.filtersObj,page:this.filterPageName});
      }, SEARCH_DEBOUNCE_TIME),
      dateSearch(val) {
        this.filtersObj.dateFrom = val.dateFrom;
        this.filtersObj.dateTo = val.dateTo;

        this.onSearch();
      },

      onClear(callSearch = true) {
        /*this.clearFilters();*/
        // Object.keys(this.filtersObj).forEach(filterName => {
        //   this.filtersObj[filterName] = null;
        // });

        this.clearObject(this.filtersObj);

        if(!roleMixin.methods.checkClaim(roleMixin.data().CAN_MANAGE_TASKS)) {this.filtersObj.assignedTo = this.userId;}
        /*this.$refs.dateRangePicker.setDateRangeAll();*/ //Clear date range picker
        if (callSearch) {
          this.search({'filters':this.filtersObj,page:this.filterPageName});
        } else {
          this.filtersObj.assignedTo = this.userId;
          this.filtersObj.statusId = 410;
        }
      },
      findIconClass(taskTypeId) {
        if (taskTypeId) {
          const myData = _.find(this.taskTypes, {id: taskTypeId});
          if (typeof myData !== 'undefined') {
            return myData.icon;
          }
        }
      },
      onRowClick(row) {
        this.selectedRowItemId = row.id;
        this.taskDetails = row;
        this.$bvModal.show('task-detail-modal');
      },

      async getTaskList() {
        this.setContainerLoader(true);

        this.setItem({ 
            resource: 'pageInfo', 
            payload: {
                ...this.pageInfo, ...this.gridSettings.pageSize, 
                sortBy: 'taskDue',
                sortOrder: 'desc',
                statusId: 410
            } 
        });
        await this.getAll({}).then(() => {
          this.setContainerLoader(false);
        }).catch(() => {
          this.setContainerLoader(false);
        });

      },
      openTodoModal(isAdd = false) {
        if (isAdd) {
          this.editDetails = {};
          this.$bvModal.show('add-task-modal');
        } else {
          this.editDetails = _.find(this.itemData, {id: this.selectedRowItemId});
          console.log(this.editDetails, "Edit Details")
          if (this.editDetails) {
            setTimeout(() => {
              this.$bvModal.show('add-task-modal');
            }, 1000);
          }
        }
      },
    },
    watch: {
      gridList() {
        if (this.gridList.length > 0 && this.selectedRowItemId === 0) {
          this.selectedRowItemId = this.gridList[0].id;
          this.taskDetails = this.gridList[0];
        } else if (this.selectedRowItemId) {
          this.taskDetails = _.find(this.gridList, {id: this.selectedRowItemId});
          if(!this.taskDetails && this.gridList.length){
            this.selectedRowItemId = this.gridList[0].id;
            this.taskDetails = this.gridList[0];
          }else if(!this.taskDetails){
            this.taskDetails = {};
          }
        } else if(!this.gridList.length){
          this.taskDetails = {};
        }
      },
      getAllUser(){
        if(!roleMixin.methods.checkClaim(roleMixin.data().CAN_MANAGE_TASKS)) {this.filtersObj.assignedTo = this.userId;}
      }
    },
    mounted() {
      //reset companyId and contactId
      this.setItem({ resource:'filterPage', payload: this.filterPageName });
      if ('clear' in this.$route.query) {
        this.pageInfo.pageNumber = 1;
        this.onClear(false);
        this.clearRoute();
      } else {
        if(!roleMixin.methods.checkClaim(roleMixin.data().CAN_MANAGE_TASKS)) {this.filtersObj.assignedTo = this.userId;}
        this.getTaskList();
        this.getAllUserList();
      }
    },
  };
</script>

<style lang="scss">
  @import '@/assets/scss/_colors.scss';

  .list-group-item.selected {
    z-index: 1;
    color: #5c6873;
    text-decoration: none;
    background-color: #f0f3f5;
  }

  .task-scrollable {
    max-height: 1310px !important;
    // height: auto;
    overflow-y: auto;
  }

  #todotasks-header-nav {
    width: 100%;
    z-index: 1000;
    position: relative;
    border-bottom: 1px solid rgb(200, 206, 211);
    background: #fff;
  }

  #todotasks-header-nav-txt {
    background-color: #fff;
    padding: 8px;
    font-size: 20px;
    margin: 0px;
  }


  .todotasks {
    &--todotasks-list {
      .tools > * {
        margin: 0 0 0 3px;
      }

      .b-pagination {
        justify-content: center;
      }

      .create-ultra-rfp {
        margin-top: 0.5em;
        margin-bottom: 1em;
      }

      table td {
        cursor: pointer;
      }

      .buttons-panel {
        text-align: right;
        margin-right: 30px;
        margin-top: 7px;

        .btn {
          margin-left: 5px;
        }

      }

      .clear-filter-button-container {
        margin-top: 12px;
        text-align: right;
      }
    }

    &--grid-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .highlight {
    background: $rowSelection !important;
  }

  .b-pagination {
    justify-content: center;
  }

  .tools > * {
    margin: 0 0 0 3px;
  }

  #KendoGrid .k-virtual-scrollable-wrap table {
    min-width: 800px;
  }
</style>
